import { NextFetch } from '@/utils/request';
import host from '@/utils/request/host';

interface Params {
  name?: string;
  mobile?: string;
  shopId?: number;
  smsCode?: string;
  smsToken?: string;
  clueSourceCode?: string; // 线索来源编码
  regionCode?: string; // 区域编码(市)
  regionName?: string; // 区域名称（省市）
  groupId?: number; // 集团id
  brandId?: number; // 品牌id
}

export async function fetchClueRegisterApi(params?: Params) {
  return await NextFetch.post<any>(`${host.crm}/h5/shopWebsite/clueRegister`, params);
}

interface VerifySMS {
  remainSecond: number;
  smsToken: string;
}

export async function verifyCodeApi(phone?: string) {
  return await NextFetch.get<VerifySMS>(`${host.sms}/code`, { phone });
}

interface RegionTreeParams {
  groupId?: number; // 集团id
  type?: number; // 1.全集团2部分门店
}

export interface RegionTreeResult extends RegionItem {
  shopRegionList?: RegionItem[]; // 子区域列表
}

export interface RegionItem {
  name?: string; // 简写区域名
  fullName?: string; // 全名;
  oldName?: string; // 原名称
  bh?: string; // 区域编码
}

export async function fetchReginTreeApi(params?: RegionTreeParams) {
  return await NextFetch.post<RegionTreeResult[]>(`${host.oop}/h5/common/post/shop/region/tree`, params);
}

interface LocationInquiryParams {
  lng?: number;
  lat?: number;
}

interface LocationInquiryResult {
  provinceCode?: string; // 省份编码
  provinceName?: string; // 省份名称
  cityCode?: string; // 城市编码
  cityName?: string; // 城市名称
}

export async function fetchLocationApi(params?: LocationInquiryParams) {
  return await NextFetch.get<LocationInquiryResult>(`${host.crm}/h5/shopWebsite/locationInquiry`, params);
}